/**
 * Loads the other pieces of a co-ord set (see snippets/complete-the-look.liquid). Defined globally so the element
 * also works when the cart drawer is re-rendered after an add to cart.
 */
if (!customElements.get('complete-the-look')) {
  customElements.define('complete-the-look', class extends HTMLElement {
    async connectedCallback() {
      if (this.loaded) {
        return;
      }

      this.loaded = true;

      try {
        const response = await fetch(this.dataset.url);

        if (!response.ok) {
          return;
        }

        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const excludeIds = (this.dataset.excludeIds || '').split(',').filter(Boolean);
        const limit = parseInt(this.dataset.limit, 10) || 2;
        const items = Array.from(html.querySelectorAll('.complete-the-look__item'))
          .filter((item) => !excludeIds.includes(item.dataset.productId))
          .slice(0, limit);

        if (items.length === 0) {
          return;
        }

        this.querySelector('.complete-the-look__list').replaceChildren(...items.map((item) => document.importNode(item, true)));
        this.hidden = false;
      } catch (error) {
        console.error(error);
      }
    }
  });
}
